import React from 'react'
import PropTypes from 'prop-types'

const LogoutOutline24 = ({ color, height, strokeWidth, width }) => (
   <svg width={width} height={height} viewBox="0 0 24 24">
      <g
         fill={color}
         stroke={color}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}>
         <line fill="none" x1="9" x2="21" y1="12" y2="12" />
         <polyline fill="none" points=" 17,16 21,12 17,8 " />
         <polyline fill="none" points="19,4 19,1 5,1 5,23 19,23 19,20 " />
      </g>
   </svg>
)

LogoutOutline24.propTypes = {
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

LogoutOutline24.defaultProps = {
   color: '#444',
   height: '24px',
   strokeWidth: '1px',
   width: '24px'
}

export default LogoutOutline24
